module.exports = __webpack_public_path__ + "static/media/tatooine.13c2a5d1.jpg";